import React, { FC } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter as Router } from "react-router-dom";
import "./assets/css/styles.scss";
import AppStateProvider from "./providers/AppStateProvider";
import FormBondApp from "./components/forms/FormBondApp";
import { GlobalStyles } from "./styles";
import { FormContextProvider } from "./FormContext";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      retryOnMount: false,
      refetchOnWindowFocus: false,
    },
  },
});

const App: FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <AppStateProvider>
          <GlobalStyles />
          <FormContextProvider>
            <FormBondApp />
          </FormContextProvider>
        </AppStateProvider>
      </Router>
    </QueryClientProvider>
  );
};

export default App;
